import { render, staticRenderFns } from "./alert-info.vue?vue&type=template&id=bb6c7a00&scoped=true&lang=pug&"
var script = {}
import style0 from "./alert-info.vue?vue&type=style&index=0&id=bb6c7a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c7a00",
  null
  
)

export default component.exports